/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Note } from '../models/Note'
import type { NoteArray } from '../models/NoteArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class NoteService {
  /**
   * 📱 Get all notes of the past 7 days for all employees assigned to the device
   * @returns any OK
   * @throws ApiError
   */
  public static getNotes(): CancelablePromise<{
    data?: NoteArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/notes',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Gets a specific note for an employee and a day
   * @param employee
   * @param day
   * @returns any OK
   * @throws ApiError
   */
  public static showNote(
    employee: number,
    day: string,
  ): CancelablePromise<{
    data?: Note
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/notes/{employee}/{day}',
      path: {
        employee: employee,
        day: day,
      },
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Store a daily Note
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storeNote(requestBody?: Note): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/notes/store',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        409: `The resource was modified and can only be updated by a newer version.`,
        422: `Request validation failed`,
      },
    })
  }
}
